import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('api')

type CreateTicketData = {
  serviceId?: string 
  linkId?: string 
  linkType?: string 
  categoryId: string 
  subjectId: string 
  text: string 
  priority: string
  title: string
}

type CreateMessageData = {
  text: string
}

export const createTicket = (data: CreateTicketData) => {
  return axiosInstance.post('/tickets/ffc',data)
}

export const createMessage = (data: CreateMessageData, id:string) => {
  return axiosInstance.post(`/tickets/${id}/message`, data)
}